(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1120],{

/***/ 78762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34853);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1216);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ReCaptcha = function ReCaptcha(props, ref) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
      ref: ref,
      sitekey: "6LeJZ68UAAAAAJZ8jxdgylEXeWL8P9Ckv7CLtE6t",
      badge: "inline",
      size: "invisible"
    }, props))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(ReCaptcha));

/***/ }),

/***/ 76761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(30266);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(40037);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(809);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./common/contexts.js
var contexts = __webpack_require__(72713);
// EXTERNAL MODULE: ./common/fetch/get.js
var get = __webpack_require__(99796);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/atoms/Toast/index.js
var Toast = __webpack_require__(85882);
// EXTERNAL MODULE: ./components/molecules/StepBar/index.js
var StepBar = __webpack_require__(85504);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(159);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 2 modules
var react_select_esm = __webpack_require__(99973);
// EXTERNAL MODULE: ./node_modules/react-select/dist/index-a86253bb.esm.js + 3 modules
var index_a86253bb_esm = __webpack_require__(57003);
// EXTERNAL MODULE: ./components/atoms/Icon/bs/BsChevronDown.js
var BsChevronDown = __webpack_require__(86456);
// EXTERNAL MODULE: ./components/templates/offshore/guide-and-tool/belize-mini-tool/Styles.module.scss
var Styles_module = __webpack_require__(10862);
var Styles_module_default = /*#__PURE__*/__webpack_require__.n(Styles_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/offshore/guide-and-tool/belize-mini-tool/screens/steps/Step1.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var customStyles = {
  container: function container(provided) {
    return _objectSpread({}, provided);
  },
  control: function control(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      borderRadius: "30px",
      backgroundColor: "#fff",
      border: "0.5px solid #ddd",
      padding: "0px 16px",
      boxShadow: "none"
    });
  },
  placeholder: function placeholder(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      color: "#333333",
      fontSize: "16px",
      fontWeight: "400"
    });
  },
  valueContainer: function valueContainer(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      padding: "4px 0px"
    });
  },
  menu: function menu(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      borderRadius: 20,
      overflow: "hidden",
      zIndex: 21
    });
  },
  menuList: function menuList(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      padding: 0
    });
  },
  option: function option(provided, state) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      padding: "8px 16px",
      color: state.isSelected ? "#002A66" : "#333",
      background: state.isSelected || state.isFocused ? "#F1FBFF" : "",
      fontWeight: state.isSelected ? "600" : "normal"
    });
  },
  input: function input(provided) {
    return _objectSpread({}, provided);
  },
  indicatorsContainer: function indicatorsContainer() {
    return {
      border: "none"
    };
  }
};
var DropdownIndicator = function DropdownIndicator(_ref) {
  var props = (0,esm_extends/* default */.Z)({}, _ref);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_a86253bb_esm.c.DropdownIndicator, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "px-1",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(BsChevronDown/* BsChevronDown */.I, {
        size: 13
      })
    })
  }));
};
function Step1(_ref2) {
  var _question$input, _question$input2;

  var question = _ref2.question,
      blacklisted = _ref2.blacklisted,
      setNextStep = _ref2.setNextStep,
      setStep2Result = _ref2.setStep2Result,
      setStep3Result = _ref2.setStep3Result,
      countries = _ref2.countries,
      prevQuestion = _ref2.prevQuestion;

  var handleNext = function handleNext(item) {
    if (item.step_3_result) {
      setStep3Result(item.step_3_result);
    }

    if (item.step_2_result) {
      setStep2Result(item.step_2_result);
    }

    if (item.next === "special") {
      if (prevQuestion.filter(function (item) {
        return item.id === 2;
      }).length > 0) {
        setNextStep(5);
      } else {
        setNextStep("final");
        setStep3Result("no");
      }
    } else {
      setNextStep(item.next);
    }
  };

  var handleSelect1 = function handleSelect1(value) {
    var blacklist = blacklisted.some(function (item) {
      return item.toLowerCase() === value || value.search(" ".concat(item.toLowerCase())) > -1 || value.search("".concat(item.toLowerCase(), " ")) > -1;
    });

    if (blacklist) {
      setStep2Result("yes");
      setNextStep("final");
    } else {
      setNextStep(3);
    }
  };

  var handleSelect2 = function handleSelect2(value) {
    if (value === "belize") {
      setStep2Result("yes");
      setNextStep("final");
    } else if (value === "none") {
      setNextStep(4);
    } else {
      var blacklist = blacklisted.some(function (item) {
        return item.toLowerCase() === value || value.search(" ".concat(item.toLowerCase())) > -1 || value.search("".concat(item.toLowerCase(), " ")) > -1;
      });

      if (blacklist) {
        setStep2Result("yes");
        setNextStep("final");
      } else {
        setNextStep(4);
      }
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "mb-2 font-medium text-bbc-accent-2",
      children: question === null || question === void 0 ? void 0 : question.title
    }), (question === null || question === void 0 ? void 0 : question.content) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      dangerouslySetInnerHTML: {
        __html: question === null || question === void 0 ? void 0 : question.content
      }
    }), (question === null || question === void 0 ? void 0 : question.answer) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mt-8",
      children: question === null || question === void 0 ? void 0 : question.answer.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mb-2 last:mb-0 lg:mb-3",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: "block w-full rounded-lg border-[0.5px] border-[#007EFF] px-6 py-4 text-left hover:bg-[#007EFF] hover:text-white",
            style: {
              boxShadow: "4px 4px 8px rgba(196, 196, 196, 0.2)"
            },
            onClick: function onClick() {
              return handleNext(item);
            },
            children: item.name
          })
        }, index);
      })
    }), (question === null || question === void 0 ? void 0 : question.input) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mt-4 lg:mt-8",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((question === null || question === void 0 ? void 0 : (_question$input = question.input) === null || _question$input === void 0 ? void 0 : _question$input.type) == 1 ? "block" : "hidden"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
          instanceId: "incorporation-nation",
          placeholder: "Choose country",
          options: countries,
          onChange: function onChange(value) {
            return handleSelect1(value.label.toLowerCase());
          },
          classNamePrefix: "select",
          components: {
            DropdownIndicator: DropdownIndicator,
            IndicatorSeparator: function IndicatorSeparator() {
              return null;
            }
          },
          className: (Styles_module_default()).selectBox,
          styles: customStyles
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((question === null || question === void 0 ? void 0 : (_question$input2 = question.input) === null || _question$input2 === void 0 ? void 0 : _question$input2.type) == 1 ? "hidden" : "block"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
          instanceId: "incorporation-nation",
          placeholder: "Choose country",
          options: [{
            label: "None",
            value: "none"
          }].concat((0,toConsumableArray/* default */.Z)(countries)),
          onChange: function onChange(value) {
            return handleSelect2(value.label.toLowerCase());
          },
          classNamePrefix: "select",
          components: {
            DropdownIndicator: DropdownIndicator,
            IndicatorSeparator: function IndicatorSeparator() {
              return null;
            }
          },
          className: (Styles_module_default()).selectBox,
          styles: customStyles
        })
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./components/templates/offshore/guide-and-tool/belize-mini-tool/screens/steps/Step2.js


function Step2(_ref) {
  var setStep = _ref.setStep,
      step2Result = _ref.step2Result;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "mb-6",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mb-6",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-0",
        children: step2Result == "yes" ? "Your Belize company is likely taxable within the jurisdiction." : "Your Belize company is likely not taxable within the jurisdiction."
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mt-4",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return setStep(3);
          },
          className: "shadow-bbc block w-full rounded-lg border-[0.5px] border-[#007EFF] px-6 py-4 text-left hover:bg-[#007EFF] hover:text-white",
          children: "See your compliance requirements"
        })
      })
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./common/fetch/getGAUserID.js
var getGAUserID = __webpack_require__(12453);
// EXTERNAL MODULE: ./common/fetch/post.js
var post = __webpack_require__(92559);
// EXTERNAL MODULE: ./common/trigger.js
var trigger = __webpack_require__(62951);
// EXTERNAL MODULE: ./components/atoms/Icon/bi/BiLoaderAlt.js
var BiLoaderAlt = __webpack_require__(7778);
// EXTERNAL MODULE: ./components/atoms/Recaptcha/index.js
var Recaptcha = __webpack_require__(78762);
;// CONCATENATED MODULE: ./components/templates/offshore/guide-and-tool/belize-mini-tool/SendForm/index.js



function SendForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SendForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SendForm_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SendForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var FormSend = function FormSend() {
  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useContext = (0,react.useContext)(contexts/* ToastContext */.uL),
      openAlert = _useContext.openAlert;

  var recaptchaRef = (0,react.useRef)();

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors;

  var onTalkClick = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Tawk_API.toggle();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onTalkClick() {
      return _ref.apply(this, arguments);
    };
  }();

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(data) {
      var token, GAUserID, newData;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsLoading(true);
              _context2.next = 3;
              return recaptchaRef.current.executeAsync();

            case 3:
              token = _context2.sent;

              if (token) {
                GAUserID = (0,getGAUserID/* default */.Z)();
                newData = SendForm_objectSpread({}, data);
                newData.contact_from_id = 31;
                newData.client_id = GAUserID ? GAUserID : "";
                newData.website_id = "1"; // Axios
                //   .post(
                //     `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/tax_tool`,
                //     NewData,
                //     {
                //       Headers: {
                //         "captcha-response": token,
                //       },
                //     }
                // )

                (0,post/* default */.Z)({
                  api: "".concat("https://core.test-lp.bbcincorp.com", "/api/portal/contact_form/tax_tool"),
                  data: newData,
                  token: token
                }).then(function (res) {
                  (0,trigger/* default */.Z)("contact_form", newData);

                  if (res.state) {
                    (0,trigger/* default */.Z)("contact_form", data, "Belize Tax Mini Tool");
                    openAlert(3000, "success"); // CloseModal();
                  } else {
                    openAlert(3000, "error");
                  }

                  setIsLoading(false);
                })["catch"](function (err) {
                  openAlert(3000, "error");
                  console.log(err);
                  setIsLoading(false);
                });
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "row ml-0 mb-4 w-full justify-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        id: "form-email",
        className: "flex flex-col justify-center p-0 sm:flex-row",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "col-12 flex justify-between rounded-full  border bg-white p-0 lg:col-7",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", SendForm_objectSpread(SendForm_objectSpread({}, register("email", {
            required: {
              value: true,
              message: "This field is required."
            },
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "invalid email address"
            }
          })), {}, {
            className: "form-control flex-auto rounded-full border-0 bg-white px-6 py-2 shadow-none placeholder:text-gray-400 focus:outline-none",
            placeholder: "Enter your email"
          })), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "submit",
            className: "m-1 hidden h-10 w-10 items-center justify-center rounded-full bg-bbc-brand-500 leading-none sm:flex",
            children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "flex items-center pr-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(BiLoaderAlt/* BiLoaderAlt */.s, {
                className: "w-9 animate-spin",
                size: 20
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/icons/send-mail.svg",
              width: 24,
              height: 24,
              alt: "send"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "submit",
          className: "mt-2 flex h-10 items-center justify-center rounded-full bg-bbc-brand-500 py-2 font-semibold leading-[26px] text-white sm:hidden",
          children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "flex items-center pr-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(BiLoaderAlt/* BiLoaderAlt */.s, {
              className: "w-9 animate-spin",
              size: 20
            })
          }) : "Send Now"
        })]
      }), errors && errors.email && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "my-2 text-center text-sm tracking-[0.15px] text-red-500",
        children: errors.email.message
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-4 text-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "mb-2",
        children: "Or "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        onClick: onTalkClick,
        className: "text-bbc-primary",
        children: "Talk to our expert"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Recaptcha/* default */.Z, {
        ref: recaptchaRef,
        className: "flex justify-center"
      })
    })]
  });
};
;// CONCATENATED MODULE: ./components/templates/offshore/guide-and-tool/belize-mini-tool/screens/steps/Step3.js





function Step3_Step2(_ref) {
  var step2Result = _ref.step2Result,
      step3Result = _ref.step3Result;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "mb-8",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mb-6 lg:mb-8",
      children: step2Result == "yes" ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-center",
        children: "Your company is required to file an annual tax return on or before 31st March."
      }) : step3Result == "yes" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-3",
          children: "Your company is required to provide the following documents:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-4",
          style: {
            fontWeight: 500
          },
          children: "(1) Certificate of Tax Exemption"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-2",
          children: "To apply for a certificate of tax exemption, you must fill out and submit:"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          className: "mb-3 pl-2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "relative mt-2 flex pl-4 before:absolute before:top-2.5 before:left-0 before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-bbc-gray before:content-[''] first:mt-0",
            children: "Form E to the International Financial Services Commission; and"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "relative mt-2 flex pl-4 before:absolute before:top-2.5 before:left-0 before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-bbc-gray before:content-[''] first:mt-0",
            children: "The Annual Declaration of Tax Exemption to the Belize International Corporate Affairs Registry (BICAR)."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-4",
          children: "You will then receive the certificate if qualified."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-4",
          style: {
            fontWeight: 500
          },
          children: "(2) Proof of your company\u2019s tax residency outside Belize"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-3",
          children: "Proof can be an authorized letter or certificate or any evidence stating that you have tax residence in a jurisdiction."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-3",
          children: "The due date for the provisions is on or before 31st March."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
            children: "*The due date is based on Belize\u2019s recent extension."
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-3",
          children: "Your company is required to provide Certificate of Tax Exemption."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-2",
          children: "To apply for a certificate of tax exemption, you must fill out and submit:"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          className: "mb-3 pl-2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "relative mt-2 flex pl-4 before:absolute before:top-2.5 before:left-0 before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-bbc-gray before:content-[''] first:mt-0",
            children: "Form E to the International Financial Services Commission; and"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "relative mt-2 flex pl-4 before:absolute before:top-2.5 before:left-0 before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-bbc-gray before:content-[''] first:mt-0",
            children: "The Annual Declaration of Tax Exemption to the Belize International Corporate Affairs Registry (BICAR)."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-3",
          children: "You will then receive the certificate if qualified."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-3",
          children: "The due date for the submission is on or before 31st March."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
            children: "*The due date is based on Belize\u2019s recent extension."
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "px-4 lg:px-0",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-4 text-center font-medium text-[#2C2C51]",
        children: "Need more help? Leave your details and we'll get back to you."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Toast/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormSend, {
          triggerName: "Ebook - Offshore Company"
        })
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./components/templates/offshore/guide-and-tool/belize-mini-tool/screens/screenQuestion.js





function screenQuestion_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function screenQuestion_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { screenQuestion_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { screenQuestion_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react-hooks/exhaustive-deps */
















var dataStep = [{
  id: 1,
  name: "Assessment",
  sub_step: []
}, {
  id: 2,
  name: "Tax Status",
  sub_step: []
}, {
  id: 3,
  name: "Compliance Requirements",
  sub_step: []
}];

function ScreenQuestion(_ref) {
  var setStartScreen = _ref.setStartScreen,
      data = _ref.data;
  var questions = data.questions;

  var _useState = (0,react.useState)(1),
      step = _useState[0],
      setStep = _useState[1];

  var _useState2 = (0,react.useState)([]),
      countries = _useState2[0],
      setCountries = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      firstRender = _useState3[0],
      setFirstScreen = _useState3[1];

  var _useState4 = (0,react.useState)(),
      nextStep = _useState4[0],
      setNextStep = _useState4[1];

  var _useState5 = (0,react.useState)(questions[0]),
      question = _useState5[0],
      setQuestion = _useState5[1];

  var _useState6 = (0,react.useState)(),
      step2Result = _useState6[0],
      setStep2Result = _useState6[1];

  var _useState7 = (0,react.useState)(),
      step3Result = _useState7[0],
      setStep3Result = _useState7[1];

  var _useState8 = (0,react.useState)([]),
      arrayQuestion = _useState8[0],
      setArrQuestion = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      isOpenPopup = _useState9[0],
      setIsOpenPopup = _useState9[1];

  var _useContext = (0,react.useContext)(contexts/* ToastContext */.uL),
      openAlert = _useContext.openAlert,
      setOpenAlert = _useContext.setOpenAlert;

  (0,react.useEffect)(function () {
    if (nextStep) {
      if (nextStep == "final") {
        setStep(2);
      } else {
        var current = questions === null || questions === void 0 ? void 0 : questions.find(function (item) {
          return item.id === nextStep;
        });
        setQuestion(current);
      }

      setArrQuestion([].concat((0,toConsumableArray/* default */.Z)(arrayQuestion), [question]));
    }
  }, [nextStep]);
  (0,react.useEffect)(function () {
    if (step) {
      if (step === 2) {
        window.localStorage.setItem("belizeTaxMiniTool", questions);
      }

      if (step === 3) {
        window.localStorage.setItem("belizeTaxMiniTool", questions);
      }
    }
  }, [step]);
  (0,react.useEffect)(function () {
    if (firstRender) {
      var dataStorage = JSON.parse(window.localStorage.getItem("belizeTaxMiniTool"));
      setFirstScreen(false);

      if (dataStorage) {
        if ((dataStorage === null || dataStorage === void 0 ? void 0 : dataStorage.step) != "") {
          setStep(dataStorage.step);
        }

        if ((dataStorage === null || dataStorage === void 0 ? void 0 : dataStorage.current_question) != "") {
          setQuestion(dataStorage.current_question);
        }

        if ((dataStorage === null || dataStorage === void 0 ? void 0 : dataStorage.prev_question) != "") {
          setArrQuestion(dataStorage.prev_question);
        }

        if ((dataStorage === null || dataStorage === void 0 ? void 0 : dataStorage.step2_result) != "") {
          setStep2Result(dataStorage.step2_result);
        }

        if ((dataStorage === null || dataStorage === void 0 ? void 0 : dataStorage.step3_result) != "") {
          setStep3Result(dataStorage.step3_result);
        }
      }
    } else {
      var dataLocal = {
        step: step || "",
        prev_question: arrayQuestion || "",
        current_question: question || "",
        step2_result: step2Result || "",
        step3_result: step3Result || ""
      };
      window.localStorage.setItem("belizeTaxMiniTool", JSON.stringify(dataLocal));
    }
  });

  function fetchCountries() {
    return _fetchCountries.apply(this, arguments);
  }

  function _fetchCountries() {
    _fetchCountries = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,get/* default */.Z)({
                url: "".concat("https://core.test-lp.bbcincorp.com", "/api/onboarding/country")
              });

            case 2:
              response = _context.sent;

              if (response.data && response.data.length > 0) {
                setCountries(response.data.map(function (item) {
                  return screenQuestion_objectSpread(screenQuestion_objectSpread({}, item), {}, {
                    label: item.name,
                    value: item.id
                  });
                }));
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _fetchCountries.apply(this, arguments);
  }

  (0,react.useEffect)(function () {
    try {
      // Async function fetchCountries() {
      //   Const response = await axios.get(
      //     `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/onboarding/country`
      //   );
      //   If (response.data && response.data.data) {
      //     SetCountries(
      //       Response.data.data.map((item) => ({
      //         ...item,
      //         Label: item.name,
      //         Value: item.id,
      //       }))
      //     );
      //   }
      // }
      fetchCountries();
    } catch (error) {
      console.error();
    }
  }, []);

  var handleBack = function handleBack() {
    if (step === 3) {
      setStep(2);
    } else if (step === 2) {
      setStep(1);
      setQuestion(arrayQuestion[arrayQuestion.length - 1]);
      setNextStep(false);
      arrayQuestion.pop();
    } else if (arrayQuestion.length > 0) {
      setQuestion(arrayQuestion[arrayQuestion.length - 1]);
      setNextStep(false);
      arrayQuestion.pop();
    }
  };

  var handleReset = function handleReset() {
    localStorage.removeItem("belizeTaxMiniTool");
    setStartScreen(true);
  };

  var onResetClick = function onResetClick() {
    openAlert(false, "custom", {
      bgAlert: "bg-white",
      element: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/icons/warning.png",
          width: 98,
          height: 100,
          alt: "icon error",
          className: "mx-auto mb-6",
          wrapper: {
            className: "block"
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: "mb-6 text-2xl font-semibold text-bbc-brand-700",
          children: ["Are you sure?", " "]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex justify-around",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
            variant: "outline",
            btnTextColor: "text-bbc-red-300 hover:text-white",
            btnBorder: "border border-bbc-red-300 hover:border-bbc-red-400",
            btnColor: "bg-transparent hover:bg-bbc-red-400",
            othersClass: "w-28",
            onClick: function onClick() {
              setOpenAlert(false);
            },
            children: "No"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
            othersClass: "w-28",
            onClick: function onClick() {
              handleReset();
              setOpenAlert(false);
            },
            children: "Yes"
          })]
        })]
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((Styles_module_default()).boxShadowOnlyPC, " shadow-b-bbc rounded-xl bg-transparent lg:bg-white"),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "py-0 px-0 lg:py-10 lg:px-20",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-2 lg:mb-8",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return onResetClick();
          },
          className: "font-medium text-bbc-primary",
          children: "Reset"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: "mb-6 text-center text-2xl font-semibold leading-9 text-bbc-brand-700 lg:mb-10 lg:text-bbc-30px",
        children: ["Belize", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
          className: "inline lg:hidden"
        }), " Tax Status Assessment"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-10",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(StepBar/* default */.Z, {
          step: step,
          data: dataStep
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-6 lg:mb-8",
        children: step === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Step1, {
          question: question,
          setNextStep: setNextStep,
          blacklisted: data.blacklisted,
          setStep2Result: setStep2Result,
          setStep3Result: setStep3Result,
          countries: countries,
          prevQuestion: arrayQuestion
        }) : step === 2 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Step2, {
          setStep: setStep,
          step2Result: step2Result
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Step3_Step2, {
          step2Result: step2Result,
          step3Result: step3Result
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return handleBack();
          },
          className: "".concat(arrayQuestion && arrayQuestion.length > 0 ? "block" : "hidden", " font-medium text-bbc-gray opacity-50"),
          disabled: arrayQuestion.length <= 0,
          children: "Back"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
        appear: true,
        show: isOpenPopup,
        as: react.Fragment,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Dialog */.Vq, {
          as: "div",
          className: "fixed inset-0 z-50 overflow-y-auto",
          onClose: function onClose() {
            return setIsOpenPopup(false);
          },
          style: {
            zIndex: 51
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "min-h-screen px-4 text-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
              as: react.Fragment,
              enter: "ease-out duration-300",
              enterFrom: "opacity-0",
              enterTo: "opacity-100",
              leave: "ease-in duration-200",
              leaveFrom: "opacity-100",
              leaveTo: "opacity-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Dialog.Overlay */.Vq.Overlay, {
                className: "fixed inset-0 bg-[rgba(0,0,0,.4)]"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "inline-block h-screen align-middle",
              "aria-hidden": "true",
              children: "\u200B"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
              as: react.Fragment,
              enter: "ease-out duration-300",
              enterFrom: "opacity-0 scale-95",
              enterTo: "opacity-100 scale-100",
              leave: "ease-in duration-200",
              leaveFrom: "opacity-100 scale-100",
              leaveTo: "opacity-0 scale-95",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "my-8 inline-block w-full max-w-lg transform overflow-hidden rounded-[10px] bg-white px-6 py-10 text-center align-middle shadow-xl transition-all",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/offshore/guide-and-tool/es-tool/warning-es_tool.svg",
                  width: 128,
                  height: 109,
                  alt: "warning"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                  text: "Are you sure?",
                  className: "mt-6 text-lg font-medium text-bbc-brand-700 lg:text-2xl lg:font-semibold lg:leading-9"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "mt-6 flex justify-center gap-x-6",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
                    onClick: function onClick() {
                      return setIsOpenPopup(false);
                    },
                    btnColor: "bg-bbc-neutral-600 hover:bg-bbc-neutral-700",
                    othersClass: " min-w-[109px] font-medium",
                    children: "No"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
                    onClick: function onClick() {
                      return handleReset();
                    },
                    othersClass: "min-w-[109px] font-medium",
                    children: "Yes"
                  })]
                })]
              })
            })]
          })
        })
      })
    })]
  });
}

function BelizeMiniTool(_ref2) {
  var setStartScreen = _ref2.setStartScreen,
      data = _ref2.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Toast/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ScreenQuestion, {
      setStartScreen: setStartScreen,
      data: data
    })
  });
}
;// CONCATENATED MODULE: ./components/templates/offshore/guide-and-tool/belize-mini-tool/screens/screenStart.js






function ScreenStart(_ref) {
  var setStartScreen = _ref.setStartScreen;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "row",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "col-12 lg:col-6",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            className: "bg-[linear-gradient(89.75deg,#BA3838_-4.9%,#FF0000_97.56%)] bg-clip-text text-center text-2xl font-semibold leading-9 tracking-[0.25px] text-transparent lg:text-left lg:text-bbc-48px ",
            children: "BELIZE"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            text: "Tax Status Assessment",
            className: "mb-4 bg-[linear-gradient(89.75deg,#3838BA_-4.9%,#00A3FF_97.56%)] bg-clip-text text-center text-2xl font-semibold leading-9 text-transparent lg:mb-6 lg:text-left lg:text-bbc-40px"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-10 lg:mb-12",
            children: "Taxation is always a foremost concern when it comes to starting your business overseas. Try this self-assessment test now to check whether your entity is taxable in Belize. And find out what your compliance obligations can be."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "hidden lg:block",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
              className: "inline-block rounded-full bg-bbc-brand-500 px-6 py-2 font-semibold leading-[26px]  tracking-[0.4px] text-white transition-all duration-200 hover:bg-bbc-brand-600 lg:font-medium ",
              onClick: function onClick() {
                return setStartScreen(false);
              },
              children: "Start Now"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "col-12 mb-10 text-center lg:col-6 lg:mb-0 lg:text-left",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
            src: "assets/images/offshore/belize-mini-tool/mini_tool-belize.png",
            alt: "belize-mini-tool",
            width: 540,
            height: 440
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "block text-center lg:hidden",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
            onClick: function onClick() {
              return setStartScreen(false);
            },
            children: "Start Now"
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "rounded-[20px] bg-transparent p-0 lg:bg-white lg:p-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-4 font-medium text-bbc-brand-700",
            children: "Disclaimer:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "The information contained in this tool is for general information purposes only. You should not substitute the information provided in this tool for competent legal advice. For further in-depth understanding of how your entity may be taxed in Belize, please engage professional advice."
          })]
        })
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/templates/offshore/guide-and-tool/belize-mini-tool/index.js
/* eslint-disable react-hooks/exhaustive-deps */







var Component = function Component(_ref) {
  var data = _ref.data;

  var _useState = (0,react.useState)(true),
      startScreen = _useState[0],
      setStartScreen = _useState[1];

  (0,react.useEffect)(function () {
    var dataLocal = null;

    if (true) {
      dataLocal = localStorage.getItem("belizeTaxMiniTool");
    }

    if (dataLocal && startScreen == true) {
      setStartScreen(false);
    }
  }, []);
  (0,react.useEffect)(function () {
    var hours = 12; // Reset when storage is more than 3days

    var now = new Date().getTime();
    var setExpirationDate = localStorage.getItem("setExpirationDate");

    if (setExpirationDate === null) {
      localStorage.setItem("setExpirationDate", now);
    } else {
      if (now - setExpirationDate > hours * 60 * 60 * 1000) {
        localStorage.clear();
        localStorage.setItem("setExpirationDate", now);
      }
    }
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container min-h-screen ".concat((Styles_module_default()).wrapper, " "),
      children: startScreen ? /*#__PURE__*/(0,jsx_runtime.jsx)(ScreenStart, {
        setStartScreen: setStartScreen
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(BelizeMiniTool, {
        setStartScreen: setStartScreen,
        data: data
      })
    })
  });
};

/* harmony default export */ var belize_mini_tool = (Component);
;// CONCATENATED MODULE: ./pages/offshore/guide-and-tool/belize-mini-tool/data.json
var data_namespaceObject = JSON.parse('{"questions":[{"id":1,"title":"Are you able to demonstrate your tax residency outside Belize with a letter or certificate?","step":1,"content":"<p class=\'mb-2 pl-2\'>Which might include:</p><ul class=\'pl-2\'><li class=\'relative flex mt-2 first:mt-0 pl-4 before:bg-bbc-gray before:top-2.5 before:left-0 before:w-1 before:h-1 before:rounded-full before:absolute before:inline-block before:content-[\'\']\'>Form or issued by the tax authority of its jurisdiction of residence, stating that the commercial entity is considered to be resident for tax purposes in that jurisdiction;</li><li class=\'relative flex mt-2 first:mt-0 pl-4 before:bg-bbc-gray before:top-2.5 before:left-0 before:w-1 before:h-1 before:rounded-full before:absolute before:inline-block before:content-[\'\']\'>Showing a clear and specific period of validity; and</li><li class=\'relative flex mt-2 first:mt-0 pl-4 before:bg-bbc-gray before:top-2.5 before:left-0 before:w-1 before:h-1 before:rounded-full before:absolute before:inline-block before:content-[\'\']\'>Showing an assessment of the tax on the entity, a confirmation of self-assessment of tax, a tax demand, evidence of tax payment, or any other equivalent document issued by the tax authority for the jurisdiction in question.</li></ul>","answer":[{"name":"Yes","value":"yes","next":2},{"name":"No","value":"no","next":3}]},{"id":2,"title":"Where is your Belize company resident for tax purposes?","step":1,"input":{"type":1,"next":3}},{"id":3,"title":"Where does your Belize company have a fixed place of business i.e., a branch, an office, a place of management, etc. through which your business wholly or partly carried on?","step":1,"input":{"type":2,"next":4}},{"id":4,"title":"Do you employ agents to perform activities in Belize so that they can habitually conclude contracts on behalf of your Belize company for the provision of your services?","step":1,"answer":[{"name":"Yes","value":"yes","step_2_result":"yes","next":"final"},{"name":"No","value":"no","step_2_result":"no","next":"special"}]},{"id":5,"title":"Does your Belize company engage in any of the following businesses?","step":1,"content":"<ul class=\'pl-2\'><li class=\'relative flex mt-2 first:mt-0 pl-4 before:bg-bbc-gray before:top-2.5 before:left-0 before:w-1 before:h-1 before:rounded-full before:absolute before:inline-block before:content-[\'\']\'>Banking;</li><li class=\'relative flex mt-2 first:mt-0 pl-4 before:bg-bbc-gray before:top-2.5 before:left-0 before:w-1 before:h-1 before:rounded-full before:absolute before:inline-block before:content-[\'\']\'>Insurance;</li><li class=\'relative flex mt-2 first:mt-0 pl-4 before:bg-bbc-gray before:top-2.5 before:left-0 before:w-1 before:h-1 before:rounded-full before:absolute before:inline-block before:content-[\'\']\'>Fund management;</li><li class=\'relative flex mt-2 first:mt-0 pl-4 before:bg-bbc-gray before:top-2.5 before:left-0 before:w-1 before:h-1 before:rounded-full before:absolute before:inline-block before:content-[\'\']\'>Financing and leasing;</li><li class=\'relative flex mt-2 first:mt-0 pl-4 before:bg-bbc-gray before:top-2.5 before:left-0 before:w-1 before:h-1 before:rounded-full before:absolute before:inline-block before:content-[\'\']\'>Headquarters;</li><li class=\'relative flex mt-2 first:mt-0 pl-4 before:bg-bbc-gray before:top-2.5 before:left-0 before:w-1 before:h-1 before:rounded-full before:absolute before:inline-block before:content-[\'\']\'>Distribution and service center;</li><li class=\'relative flex mt-2 first:mt-0 pl-4 before:bg-bbc-gray before:top-2.5 before:left-0 before:w-1 before:h-1 before:rounded-full before:absolute before:inline-block before:content-[\'\']\'>Shipping;</li><li class=\'relative flex mt-2 first:mt-0 pl-4 before:bg-bbc-gray before:top-2.5 before:left-0 before:w-1 before:h-1 before:rounded-full before:absolute before:inline-block before:content-[\'\']\'>As a holding company, engaged, or where one or more of its subsidiaries is engaged in one of the activities listed above.</li></ul>","answer":[{"name":"Yes","value":"yes","step_3_result":"yes","next":"final"},{"name":"No","value":"no","step_3_result":"no","next":"final"}]}],"blacklisted":["American Samoa","Fiji","Guam","Palau","Panama","Samoa","Trinidad & Tobago","U.S. Virgin Islands","Vanuatu"]}');
;// CONCATENATED MODULE: ./pages/offshore/guide-and-tool/belize-mini-tool/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      locationRouter: "offshore",
      page: data.page,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(belize_mini_tool, {
        data: data_namespaceObject
      })
    })
  });
}

/***/ }),

/***/ 78386:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/guide-and-tool/belize-mini-tool",
      function () {
        return __webpack_require__(76761);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10862:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selectBox":"Styles_selectBox__w42a9","boxShadowOnlyPC":"Styles_boxShadowOnlyPC__05PBq","wrapper":"Styles_wrapper__K5UHC"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3105,9593,9885,9973,4090,9738,9663,9774,2888,179], function() { return __webpack_exec__(78386); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);